module.exports = __webpack_public_path__ + "static/media/upgrade_scoops.1b26e11d.png";